import script from "./AdminMarketing.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminMarketing.vue?vue&type=script&setup=true&lang=js"

import "./AdminMarketing.vue?vue&type=style&index=0&id=1e712434&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e712434"]])

export default __exports__